/** Tiny synchronous event bus. Zero allocation on emit for <=4 args. */
export class EventBus {
  constructor() { this.map = new Map(); }
  on(type, fn, ctx = null) {
    let a = this.map.get(type); if (!a) this.map.set(type, (a = []));
    a.push({ fn, ctx }); return () => this.off(type, fn);
  }
  once(type, fn, ctx = null) {
    const un = this.on(type, (...args) => { un(); fn.apply(ctx, args); });
    return un;
  }
  off(type, fn) {
    const a = this.map.get(type); if (!a) return;
    for (let i = a.length - 1; i >= 0; i--) if (a[i].fn === fn) a.splice(i, 1);
  }
  emit(type, a, b, c, d) {
    const arr = this.map.get(type); if (!arr) return;
    for (let i = 0; i < arr.length; i++) arr[i].fn.call(arr[i].ctx, a, b, c, d);
  }
  clear() { this.map.clear(); }
}
